"use client";

import { c as _c } from "react/compiler-runtime";
import type { LucideIcon } from "lucide-react";
import { ImageIcon } from "lucide-react";
import Image, { type ImageProps } from "next/image";
import { useState } from "react";
type ProductImageProps = Omit<ImageProps, "src"> & {
  src: string | null | undefined;
  iconClassName?: string;
  icon?: LucideIcon;
};
export function ProductImage(t0) {
  const $ = _c(18);
  let fetchPriority;
  let onError;
  let rest;
  let src;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      src,
      iconClassName: t1,
      icon: t2,
      onError,
      fetchPriority,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = fetchPriority;
    $[2] = onError;
    $[3] = rest;
    $[4] = src;
    $[5] = t1;
    $[6] = t2;
  } else {
    fetchPriority = $[1];
    onError = $[2];
    rest = $[3];
    src = $[4];
    t1 = $[5];
    t2 = $[6];
  }
  const iconClassName = t1 === undefined ? "w-8 h-8" : t1;
  const Icon = t2 === undefined ? ImageIcon : t2;
  const [hasError, setHasError] = useState(false);
  if (!src || hasError) {
    let t3;
    if ($[7] !== Icon || $[8] !== iconClassName) {
      t3 = <div className="absolute inset-0 flex items-center justify-center bg-gray-100 text-gray-300"><Icon className={iconClassName} /></div>;
      $[7] = Icon;
      $[8] = iconClassName;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    return t3;
  }
  let t3;
  if ($[10] !== onError) {
    t3 = e => {
      setHasError(true);
      onError?.(e);
    };
    $[10] = onError;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const t4 = fetchPriority === "high" ? "eager" : undefined;
  let t5;
  if ($[12] !== fetchPriority || $[13] !== rest || $[14] !== src || $[15] !== t3 || $[16] !== t4) {
    t5 = <Image src={src} onError={t3} fetchPriority={fetchPriority} loading={t4} {...rest} />;
    $[12] = fetchPriority;
    $[13] = rest;
    $[14] = src;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
}